module.exports = __webpack_public_path__ + "static/img/1-10.f90dd71.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-10.png
// module id = 211
// module chunks = 0